<template>
  <div v-frag> 
    <CardIeaAppMain colorCard="#A7BA38" title="Clases">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.push({ name: 'Home' })"
        >
          <v-icon dark> mdi-keyboard-backspace </v-icon>
        </v-btn>
        <br /><br />

        <div
          class="
            text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4
            primary--text
          "
        >
          Test / Mis Materias
        </div>

        <div>
          <br />
          <h2>Mis Materias</h2>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Materia</th>
                  <!-- <th class="text-left">Sede</th> -->
                  <!-- <th>Test</th> -->
                  <th class="text-left">
                    Clase Sincronica (Vivo)
                  </th>
                  <th class="text-left">
                    Contenido Asincronico (Grabado)
                  </th>
                  <th class="text-left">
                    Google Drive
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(clase, index) in clases" :key="index">
                  <td>{{ clase.id }}</td>
                  <td>{{ clase.nombre }}</td>
                  <!-- <td>{{ clase.sede }}</td> -->
                  <!-- <td>
                    <v-btn
                      @click="listaTest(clase.materia_id)"
                      small
                      class="
                        info--text
                        text-decoration-underline
                        font-weight-regular
                      "
                      depressed
                      text
                      color="info"
                      >Ver</v-btn
                    >
                  </td> -->
                  <td align="center" >
                    <div v-if="clase.code">
                      <v-btn  :href="linkMeet(clase.code)" small
                      class="info--text text-decoration-underline font-weight-regular" depressed text color="info"
                      >
                      Ver Aquí
                    </v-btn>
                    </div>
                    <div v-frag v-else>
                      <b class="text-center">Sin contenido aún</b>
                    </div>
                  </td>
                  <td align="center" >
                    <div v-frag v-if="clase.ruta">
                      <v-btn @click="linkVideo(clase.uuid, clase.materia_IDStB)" small
                        class="info--text text-decoration-underline font-weight-regular" depressed text color="info">Ver
                        Aquí</v-btn>
                    </div>
                    <div v-frag v-else>
                      <b class="text-center">Sin contenido aún</b>
                    </div>
                  </td>
                  <td align="center" >
                    <v-btn v-if="clase.google_drive != null" :href="clase.google_drive" target="_blank" small
                      class="info--text text-decoration-underline font-weight-regular" depressed text color="info"
                      >
                      Ver Aquí
                    </v-btn>
                    <div v-frag v-else>
                      <b class="text-center">Sin contenido aún</b>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>

        <!-- <div>
          <br />
          <h2>Mis Test</h2>
          
          <v-btn
            v-if="tests != null"
            @click="nuevoTest = true"
            small
            class="info--text text-decoration-underline font-weight-regular"
            depressed
            text
            color="success"
            >agregar</v-btn
          >
         
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Test</th>
                  <th class="text-left">Cantidad Preguntas Mostrar</th>
                  <th class="text-left">Tipo</th>
                  <th class="text-left">Fecha</th>
                  <th class="text-left">Hora Inicio</th>
                  <th class="text-left">Hora Final</th>
                  <th class="text-left">Url Meet</th>
                  <th class="text-left"></th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(test, index) in tests" :key="index">
                  <td>{{ test.id }}</td>
                  <td>{{ test.name }}</td>
                  <td>{{ test.cantidad_mostrar }}</td>
                  <td>{{ test.tipo }}</td>
                  <td>{{ test.fecha_test }}</td>
                  <td>{{ test.hora_inicio }}</td>
                  <td>{{ test.hora_final }}</td>
                  <td>{{ test.url_meet }}</td>
                  <td>
                    <v-btn
                      @click.native.stop="preguntas = true"
                      v-on:click="listaPreguntas(test.id)"
                      small
                      class="
                        info--text
                        text-decoration-underline
                        font-weight-regular
                      "
                      depressed
                      text
                      color="info"
                      >ver</v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div> -->
      </v-col>

      <!-- <v-dialog v-model="preguntas" max-width="1200">
        <v-card>
          <v-card-title class="headline">Preguntas</v-card-title>
          <div>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">#</th>
                    <th class="text-left">Pregunta</th>
                    <th class="text-left">Tipo de Pregunta</th>
                    <th class="text-left">Dificultad</th>
                    <th class="text-left">Tiempo de Respuesta</th>
                    <th class="text-left"></th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(pregunta, index) in preguntasTest" :key="index">
                    <td>{{ pregunta.id }}</td>
                    <td>{{ pregunta.pregunta }}</td>
                    <td>{{ pregunta.tipo }}</td>
                    <td>{{ pregunta.dificultad }}</td>
                    <td>{{ pregunta.tiempo_respuesta }}</td>
                    <td>
                      <v-btn
                        @click.native.stop="modelrespuestas = true"
                        v-on:click="listaRespuestas(pregunta)"
                        small
                        class="
                          info--text
                          text-decoration-underline
                          font-weight-regular
                        "
                        depressed
                        text
                        color="info"
                        >ver respuestas</v-btn
                      >
                    </td>
                    <td>
                      <v-btn
                        @click="eliminarPregunta(pregunta.id)"
                        small
                        class="
                          danger--text
                          text-decoration-underline
                          font-weight-regular
                        "
                        depressed
                        text
                        color="red"
                        >eliminar</v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" @click.native="preguntas = false"
              >Cerrar</v-btn
            >
            <v-btn color="green darken-1" @click.native="nuevaPregunta = true"
              >Agregar Pregunta</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="modelrespuestas" max-width="1200">
        <v-card>
          <v-card-title class="headline">Respuestas</v-card-title>
          <div>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">#</th>
                    <th class="text-left">Respuesta</th>
                    <th class="text-left">Correcta</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(respuesta, index) in respuestas" :key="index">
                    <td>{{ respuesta.id }}</td>
                    <td>{{ respuesta.respuesta }}</td>
                    <td>{{ respuesta.correcta }}</td>
                    <td>
                      <v-btn
                        @click="eliminarRespuesta(respuesta.id)"
                        small
                        class="
                          danger--text
                          text-decoration-underline
                          font-weight-regular
                        "
                        depressed
                        text
                        color="red"
                        >eliminar</v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              @click.native="modelrespuestas = false"
              >Cerrar</v-btn
            >
            <v-btn color="green darken-1" @click.native="nuevaRespuesta = true"
              >Nueva Respuesta</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-row justify="center">
        <v-dialog v-model="nuevaRespuesta" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Nueva Respuesta</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="res"
                      label="Respuesta*"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="respuestaCorrecta"
                      :items="['si', 'no']"
                      label="¿ Respuesta Correcta ?"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="nuevaRespuesta = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="guardarRespuesta()">
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <v-row justify="center">
        <v-dialog v-model="nuevaPregunta" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Nueva Pregunta</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="Npregunta"
                      label="Pregunta*"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-select
                      v-model="tipoPregunta"
                      :items="['Mono Option']"
                      label=" Tipo de pregunta "
                      required
                    ></v-select>
                  </v-col>

                  <v-col cols="12">
                    <v-select
                      v-model="dificultadPregunta"
                      :items="['facil', 'intermedio', 'dificil']"
                      label="Dificultad"
                      required
                    ></v-select>
                  </v-col>

                  <v-row>
                    <v-col cols="12">
                      <v-dialog
                        ref="dialog"
                        v-model="modal2"
                        :return-value.sync="tiempoRespuesta"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="tiempoRespuesta"
                            label="Tiempo de Respuesta"
                            prepend-icon="mdi-clock-time-four-outline"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          format="24hr"
                          v-model="tiempoRespuesta"
                          full-width
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal2 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.dialog.save(tiempoRespuesta)"
                          >
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-dialog>
                    </v-col>
                  </v-row>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="nuevaPregunta = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="guardarPregunta()">
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <v-row justify="center">
        <v-dialog v-model="nuevoTest" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Nuevo Test</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="nombreTest"
                      label="Nombre del Test"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="cantidadMostrar"
                      label="Cantidad Preguntas a Mostrar"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-select
                      v-model="tipoTest"
                      :items="['Practica', 'Examen Final']"
                      label=" Tipo de Test"
                      required
                    ></v-select>
                  </v-col>

                  <v-col cols="12">
                    <v-dialog
                      ref="fechaModalExamen"
                      v-model="fechaModalExamen"
                      :return-value.sync="fechaExamen"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="fechaExamen"
                          label="Fecha del test"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="fechaExamen" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="fechaModalExamen = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.fechaModalExamen.save(fechaExamen)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>

                  <v-col cols="12">
                    <v-dialog
                      ref="testModalInicio"
                      v-model="testModalInicio"
                      :return-value.sync="horaInicio"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="horaInicio"
                          label="Inicio del Test"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-model="horaInicio"
                        full-width
                        :max="horaFinal"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="testModalInicio = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.testModalInicio.save(horaInicio)"
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-col>

                  <v-col cols="12">
                    <v-dialog
                      ref="testModalFinal"
                      v-model="testModalFinal"
                      :return-value.sync="horaFinal"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="horaFinal"
                          label="Final del test"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-model="horaFinal"
                        full-width
                        :min="horaInicio"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="testModalFinal = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.testModalFinal.save(horaFinal)"
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="urlMeet"
                      label="URL meet"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="nuevoTest = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="guardarTest()">
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row> -->
    </CardIeaAppMain>
  </div>
</template>
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
export default {
  name: "Test",
  components: {
    CardIeaAppMain,
  },
  data() {
    return {
      urlMeet: "",
      testModalInicio: false,
      horaInicio: "",
      testModalFinal: false,
      horaFinal: "",
      fechaExamen: "",
      clases: [],
      user: [],
      tests: null,
      preguntasTest: [],
      preguntas: false,
      respuestas: [],
      modelrespuestas: false,
      nuevaRespuesta: false,
      res: "",
      respuestaCorrecta: "",
      pregunta_id: "",
      test_id: "",
      tiempoRespuesta: null,
      menu2: false,
      modal2: false,
      nuevaPregunta: false,
      Npregunta: "",
      tipoPregunta: "",
      dificultadPregunta: "",
      nuevoTest: false,
      nombreTest: "",
      cantidadMostrar: "",
      materia: "",
      tipoTest: "",
      fechaModalExamen: false,
    };
  },
  mounted() {
    this.user = this.$store.getters.user;

    this.$API
      .get({
        url: "profesor-clases-catedras",
      })
      .then((res) => {
      
        this.clases = Object.values(res.data.reduce((acc,cur)=>Object.assign(acc,{[cur.nombre]:cur}),{}));

        console.log(this.clases);
      });
  },
  methods: {
    linkMeet(code) {
      return 'https://meet.google.com/' + code;
    },
    linkVideo(catedra, planestudio) {
      this.$router.push({
        name: "MateriaCodigoClaseVideoAuth",
        params: {
          catedra: catedra,
          planestudio: planestudio
        }
      });
    },
    listaTest(materia) {
      this.materia = materia;
      this.$API
        .get({
          url: "profesor/lista-test/" + materia,
        })
        .then((res) => {
          this.tests = res;
        });
    },
    guardarTest() {
      this.$API
        .post({
          url: "pyr-add",
          data: {
            nombre: this.nombreTest,
            cantidad_mostrar: this.cantidadMostrar,
            id_materia: this.materia,
            tipo: this.tipoTest,
            fecha_test: this.fechaExamen,
            hora_inicio: this.horaInicio,
            hora_final: this.horaFinal,
            url_meet: this.urlMeet,
          },
        })
        .then(() => {
          this.listaTest(this.materia);
          this.nuevoTest = false;
        });
    },
    listaPreguntas(test) {
      this.test_id = test;
      this.$API
        .get({
          url: "pyr-preguntas/profesor/" + test,
        })
        .then((res) => {
          this.preguntasTest = res;
        });
    },

    guardarPregunta() {
      this.$API
        .post({
          url: "guardar/pregunta",
          data: {
            test_id: this.test_id,
            pregunta: this.Npregunta,
            tipo: this.tipoPregunta,
            dificultad: this.dificultadPregunta,
            tiempo_respuesta: this.tiempoRespuesta,
          },
        })
        .then(() => {
          this.listaPreguntas(this.test_id);
          this.nuevaPregunta = false;
        });
    },

    eliminarPregunta(pregunta) {
      this.$API
        .post({
          url: "eliminar/pregunta/" + pregunta,
        })
        .then((res) => {
          this.listaPreguntas(res.test.id);
        });
    },

    listaRespuestas(pregunta) {
      this.pregunta_id = pregunta.id;

      this.$API
        .get({
          url: "profesor/pyr-pregunta-docente/" + pregunta.id,
        })
        .then((res) => {
          this.respuestas = res.respuestas;
        });
    },
    eliminarRespuesta(respuesta) {
      this.$API
        .post({
          url: "eliminar/respuesta/" + respuesta,
        })
        .then((res) => {
          this.listaRespuestas(res.pregunta);
          //this.modelrespuestas = false;
        });
    },
    guardarRespuesta() {
      this.$API
        .post({
          url: "guardar/respuesta",
          data: {
            pregunta_id: this.pregunta_id,
            respuesta: this.res,
            tipo: this.tipoPregunta,
            correcta: this.respuestaCorrecta,
          },
        })
        .then((res) => {
          this.listaRespuestas(res.pregunta);
          this.nuevaRespuesta = false;
        });
    },
  },
};
</script>